import AreaAbrangenciaModel from "../models/areaAbrangencia/areaAbrangenciaModel";

import { iServiceCached } from "./base/iServiceCached";

class AreaAbrangenciaService extends iServiceCached<AreaAbrangenciaModel> {
    constructor() {
        super("AreaAbrangencia");
    }
}

export default new AreaAbrangenciaService();
